import React from 'react'
import { AppCardTitle, AppDataTable, NoDataFound, AppResultsSkeleton } from "@components"
import LeadingTableToolbar from "Pages/BusinessLogistics/LeadingAnalyzer/Page/Table/Toolbar"
import { tableData, tableOption, formData } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { officeNameColumn, priceColumn } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/Table/@columns"
import useLeadingAnalyzerFilters from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@hooks/useFilters"
import { isLoadingCommonFilters } from "@signals"
import { postExcel } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"


export default function LeadingAnalyzerTable() {

	useLeadingAnalyzerFilters()

	if (isLoadingCommonFilters.value) {
		return <AppResultsSkeleton columns={5}/>
	} else if (tableData.value?.noResults) {
		return <NoDataFound/>
	} else if (tableData.value.empty) {
		return null
	}

	return <AppDataTable
		title={<AppCardTitle icon="trophy" title="Leading Price Table"/>}
		options={{
			customToolbar: () => <LeadingTableToolbar/>,
			onDownload: () => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, formData.value)
		}}
		data={tableData.value[tableOption.value]}
		columns={[officeNameColumn(), ...tableData.value.xList.map(value => priceColumn(value))]}
	/>
}